import { render, staticRenderFns } from "./VideoListView.vue?vue&type=template&id=3d10d133"
import script from "./VideoListView.vue?vue&type=script&lang=js"
export * from "./VideoListView.vue?vue&type=script&lang=js"
import style0 from "./VideoListView.vue?vue&type=style&index=0&id=3d10d133&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports